<script setup>
import ToggleApikomContentPendedAtAction from "@frontJs/components/actions/projectManagement/seo/ToggleApikomContentPendedAtAction.vue";
import ToggleApikomContentProcessedAtAction from "@frontJs/components/actions/projectManagement/seo/ToggleApikomContentProcessedAtAction.vue";
import UpdateTenantECommerceCategoryContentAction from "@frontJs/components/actions/projectManagement/seo/UpdateTenantECommerceCategoryContentAction.vue";
import UpdateTenantECommerceProductContentAction from "@frontJs/components/actions/projectManagement/seo/UpdateTenantECommerceProductContentAction.vue";
import {
  CheckIcon,
  PencilIcon,
  XMarkIcon,
  ClockIcon,
  PencilSquareIcon,
} from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useRoute } from "@js/utils/route";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const { tenant, row, callback } = defineProps({
  tenant: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
});

const { t } = useI18n();

const { route } = useRoute();

function updateActionCallback() {
  toast.clearAll();
  toast.success(t("all.toast.successfullyUpdated"), { position: "top-right" });
  callback();
}
</script>

<template>
  <div class="flex h-full items-center gap-2 p-4">
    <ToggleApikomContentPendedAtAction
      v-if="row.original.processedAt === null"
      :tenant="tenant"
      :seo-apikom-content="row.original"
      :callback="updateActionCallback"
    >
      <template #button="{ action }">
        <ActionButton
          size="small"
          type="secondary"
          class="size-8"
          :callback="() => action()"
          :title="
            row.original.pendedAt ? t('button.unprocess') : t('button.pend')
          "
          :icon="row.original.pendedAt ? XMarkIcon : ClockIcon"
        />
      </template>
    </ToggleApikomContentPendedAtAction>

    <ToggleApikomContentProcessedAtAction
      :tenant="tenant"
      :seo-apikom-content="row.original"
      :callback="updateActionCallback"
    >
      <template #button="{ action }">
        <ActionButton
          size="small"
          type="secondary"
          class="size-8"
          :callback="() => action()"
          :title="
            row.original.processedAt
              ? t('button.unprocess')
              : t('button.process')
          "
          :icon="row.original.processedAt ? XMarkIcon : CheckIcon"
        />
      </template>
    </ToggleApikomContentProcessedAtAction>

    <ActionButton
      size="small"
      class="size-8"
      :title="t('button.edit')"
      :href="
        route('front.projectManagement.seo.updateApikomContent', {
          tenant: tenant.id,
          id: row.original.id,
        })
      "
      :icon="PencilIcon"
    />

    <UpdateTenantECommerceCategoryContentAction
      v-if="row.original.eCommerceCategory"
      :tenant="tenant"
      :e-commerce-category="row.original.eCommerceCategory"
      :seo-apikom-content="row.original"
      :callback="callback"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :callback="
            () => {
              setIsOpen(true);
            }
          "
          :icon="PencilSquareIcon"
          :title="t('button.editContent')"
        />
      </template>
    </UpdateTenantECommerceCategoryContentAction>

    <UpdateTenantECommerceProductContentAction
      v-if="row.original.eCommerceProduct"
      :tenant="tenant"
      :e-commerce-product="row.original.eCommerceProduct"
      :seo-apikom-content="row.original"
      :callback="callback"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :callback="
            () => {
              setIsOpen(true);
            }
          "
          :icon="PencilSquareIcon"
          :title="t('button.editContent')"
        />
      </template>
    </UpdateTenantECommerceProductContentAction>
  </div>
</template>
